import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/admin/customers")({
  head: () => ({
    meta: [
      { title: "Customer review · Landoo Admin" },
      { name: "description", content: "Customer review — Landoo admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Customer review" role="Admin" items={ADMIN_NAV}>
      <PlaceholderCard
        title="Customer review"
        description="Admin queue for Customer review. Actions and filters will be added here."
      />
    </DashboardShell>
  ),
});
